(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const selectors = [
    '.norvy-home-product__media',
    '.norvy-home-product__content',
    '.norvy-visual__content',
    '.norvy-visual__media',
    '.norvy-movement__content',
    '.norvy-movement__media',
    '.norvy-colors__heading',
    '.norvy-colors__labels',
    '.norvy-colors__swatches',
    '.norvy-colors__media',
    '.norvy-colors__button',
    '.image-with-text__media',
    '.image-with-text__content',
    '.rich-text__blocks',
    '.collapsible-content__header',
    '.main-page-title',
    '.main-page .rte',
    '.product__media-wrapper',
    '.product__info-wrapper',
    '.collection__title',
    '.title-wrapper-with-link',
    '.norvy-tracking__card',
    '.norvy-tracking__delivery',
    '.norvy-tracking__faq',
    '[class*="faq-teaser-"][class$="__intro"]',
    '.norvy-about__reveal',
    '.footer__content-bottom'
  ];

  const staggerSelectors = [
    '.norvy-detail-benefit',
    '.norvy-movement__features > li',
    '.norvy-home-benefits__card',
    '.product-grid > .grid__item',
    '.collection-list > .grid__item',
    '.multicolumn-list > .multicolumn-list__item',
    '.collapsible-content .accordion',
    '.norvy-tracking-step',
    '[class*="faq-teaser-"][class$="__link"]',
    '.norvy-about__pillar',
    '.footer__blocks-wrapper > .footer-block'
  ];

  const softSelectors = [
    '.norvy-home-product__content',
    '.norvy-visual__content',
    '.norvy-movement__content',
    '.norvy-colors__heading',
    '.norvy-colors__labels',
    '.rich-text__blocks',
    '.collapsible-content__header',
    '.main-page-title',
    '.main-page .rte',
    '.collection__title',
    '.title-wrapper-with-link',
    '.norvy-tracking__card',
    '.norvy-tracking__delivery',
    '.norvy-tracking__faq',
    '[class*="faq-teaser-"][class$="__intro"]',
    '.norvy-about__reveal',
    '.footer__content-bottom'
  ].join(',');

  const observed = new WeakSet();
  let observer;

  const isExcluded = (element) => {
    if (element.closest('header, .shopify-section-group-header-group, #shopify-pc__banner')) return true;

    const section = element.closest('#MainContent > .shopify-section');
    return Boolean(section && section.matches(':first-child') && section.querySelector('.banner'));
  };

  const register = (element, index = 0) => {
    if (observed.has(element) || isExcluded(element)) return;

    observed.add(element);
    element.classList.add('scroll-reveal');
    if (element.matches(softSelectors)) element.classList.add('scroll-reveal--soft');
    element.style.setProperty('--scroll-reveal-delay', `${Math.min(index, 5) * 80}ms`);

    const rect = element.getBoundingClientRect();
    if (reducedMotion.matches || (rect.top < window.innerHeight * 0.92 && rect.bottom > 0)) {
      element.classList.add('scroll-reveal--visible');
      return;
    }

    observer.observe(element);
  };

  const collect = (root = document) => {
    root.querySelectorAll(selectors.join(',')).forEach((element) => register(element));

    root.querySelectorAll(staggerSelectors.join(',')).forEach((element) => {
      const parent = element.parentElement;
      const siblings = parent
        ? Array.from(parent.children).filter((child) => child.matches(staggerSelectors.join(',')))
        : [element];
      register(element, Math.max(0, siblings.indexOf(element)));
    });
  };

  const init = () => {
    if (!('IntersectionObserver' in window)) return;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('scroll-reveal--visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -4% 0px' }
    );

    collect();
    document.documentElement.classList.add('scroll-reveal-enabled');

    document.addEventListener('shopify:section:load', (event) => collect(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
